// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"09ed6dff","506":"98838f75","707":"490df2d7"}[chunkId] + ".js";
};